import React, { useEffect, useRef, useState } from 'react';
const INITIAL_WAIT_TIME = 10;
const COUNTDOWN_SECONDS = 60;
export function useTwoFactorVerify({ onContinue, onResend, disabled = false, error: externalError = null, }) {
    const [values, setValues] = useState(Array(6).fill(''));
    const [showInlineError, setShowInlineError] = useState(true);
    const [displayError, setDisplayError] = useState(null);
    const [showResendMessage, setShowResendMessage] = useState(false);
    const [canResend, setCanResend] = useState(false);
    const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);
    const inputsRef = useRef(Array(6)
        .fill(null)
        .map(() => React.createRef()));
    useEffect(() => {
        if (externalError) {
            setDisplayError(externalError);
            setShowInlineError(true);
        }
        else {
            setDisplayError(null);
        }
    }, [externalError]);
    useEffect(() => {
        if (!showResendMessage) {
            const timer = setTimeout(() => {
                setShowResendMessage(true);
            }, INITIAL_WAIT_TIME * 1000);
            return () => clearTimeout(timer);
        }
    }, [showResendMessage]);
    useEffect(() => {
        let timer;
        if (showResendMessage && !canResend && countdown > 0) {
            timer = setTimeout(() => {
                setCountdown(prev => prev - 1);
            }, 1000);
        }
        else if (showResendMessage && countdown === 0) {
            setCanResend(true);
        }
        return () => clearTimeout(timer);
    }, [showResendMessage, canResend, countdown]);
    const handleChange = (index, value) => {
        if (value.length > 1)
            return;
        const newValues = [...values];
        newValues[index] = value.toUpperCase();
        setValues(newValues);
        if (value && index < 5) {
            inputsRef.current[index + 1]?.current?.focus();
        }
    };
    const handleContinue = () => {
        setDisplayError(null);
        setShowInlineError(false);
        onContinue(values.join(''));
    };
    const handleResendCode = () => {
        setCanResend(false);
        setCountdown(COUNTDOWN_SECONDS);
        setValues(Array(6).fill(''));
        onResend();
    };
    return {
        values,
        handleChange,
        handleContinue,
        handleResendCode,
        disabled,
        displayError,
        showInlineError,
        setShowInlineError,
        showResendMessage,
        canResend,
        countdown,
        inputsRef,
    };
}
